"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Deferred =
/*#__PURE__*/
function () {
  function Deferred() {
    var _this = this;

    _classCallCheck(this, Deferred);

    this._promise = new Promise(function (resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });
  }

  _createClass(Deferred, [{
    key: "update",
    value: function update(value) {
      this._resolve(value);
    }
  }, {
    key: "set",
    value: function set(value) {
      this.current = value;

      this._resolve(value);
    }
  }, {
    key: "fail",
    value: function fail(e) {
      this._reject(e);
    }
  }, {
    key: "promise",
    get: function get() {
      return this._promise;
    }
  }]);

  return Deferred;
}();

exports.Deferred = Deferred;